// extracted by mini-css-extract-plugin
export default {"page":"Order_page__QQF8O"};